import { useEffect, useState } from "react";
import "./style.css";
import { ReportApis } from '../../apis/ReportApis'
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";


export default function Report() {

  const [leads, setLeads] = useState([]);
  const [page, setPage] = useState(1)
  // eslint-disable-next-line no-unused-vars
  const [limit, _setLimit] = useState(10)
  const [totalpage, setTotalPage] = useState(10)  
  const history = useHistory()

  useEffect(() => {
    // Fetch dashboard data here
    ReportApis.listAll(page,limit).then(response => {
      setLeads(response.data.reports);
      setTotalPage(+response.data.pagination.totalPages)
    }).catch(error => {
      console.log(error.status)
      if(error.status === 401){
        localStorage.removeItem('token')
        history.push('/login')
      }
      console.error("Error fetching leads data:", error);
    })
  }, [page,limit,history]);


  const downloadExcel = () => {
    ReportApis.export().then(response => {
      const blob = new Blob([response.data]);
      const downloadUrl = window.URL.createObjectURL(blob)
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = 'data.xlsx'; // Suggest a filename
      document.body.appendChild(link);
      link.click(); // Programmatically click the link

      // Clean up
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    })
  }
  

  const handleNext = () => {
    if(page < totalpage){
      setPage(page + 1)
    }
  }

  const handlePrev = () => {
    if(page > 1){
      setPage(page - 1)
    }
  }

  return (
    <div className="app-layout">

      {/* Content */}
      <main >
        <div className="dashboard-header">
          <h1>
            Report
          </h1>
          <div>
            {/* <Link
              to="/form?action=add"
              className="dashboard-header-link"
            >Add Lead</Link> */}
            <button className="dashboard-header-link"
              onClick={() => downloadExcel()}
            >
              Download Excel
            </button>
          </div>
        </div>

        <div className="dashboard-section">
          <div className="dashboard-section-title">Reports</div>

          <table className="dashboard-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Designation</th>
                <th>Organization</th>
                <th>Mobile</th>
                <th>Email</th>
                <th>Created At</th>
                {/* <th>Action</th> */}
              </tr>
            </thead>
            <tbody>
              {leads.map((lead, index) => (
                <tr key={index}>
                  {/* <td>{lead.id}</td> */}
                  <td>{lead.name}</td>
                  <td>{lead.designation}</td>
                  <td>{lead.organization}</td>
                  <td>{lead.mobile}</td>
                  <td>{lead.email}</td>
                  <td>{lead.formatted_date}</td>
                  {/* <td>
                    <Link
                      to={`/form/${lead.id}?action=update`}
                    >Update</Link>
                    <button onClick={() => handleDelete(lead.id)} className="action-link">Delete</button>
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div>
          <button className="btn" onClick={() => handlePrev()}>Prev</button>
          <button className="btn" onClick={() => handleNext()}>Next</button>
        </div>
      </main>
    </div>
  );
}
